import { Link, useLocation } from 'react-router-dom';
import { clearToken } from '@/lib/api';

const NAV = [
  { to: '/', label: 'Visão geral', end: true },
  { to: '/billing', label: 'Assinaturas' },
  { to: '/clients', label: 'Clientes' },
  { to: '/translations', label: 'Traduções' },
  { to: '/media', label: 'Curadoria ML' },
  { to: '/compliance', label: 'Compliance' },
];

export function Shell({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100">
      <header className="border-b border-neutral-800 bg-neutral-900/80 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3">
          <div className="flex min-w-0 flex-1 items-center gap-6">
            <span className="shrink-0 text-sm font-semibold tracking-wide">Manejai Manager</span>
            <nav className="flex flex-wrap gap-3 text-sm">
              {NAV.map((item) => {
                const active = item.end
                  ? location.pathname === item.to
                  : location.pathname === item.to || location.pathname.startsWith(`${item.to}/`);
                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    className={active ? 'text-white' : 'text-neutral-400 hover:text-white'}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </div>
          <button
            type="button"
            onClick={() => {
              clearToken();
              window.location.href = '/login';
            }}
            className="shrink-0 text-sm text-neutral-400 hover:text-white"
          >
            Sair
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6">{children}</main>
    </div>
  );
}
